import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";

/**
 * Toggle
 *
 * Props:
 *   checked     bool
 *   onChange    () => void        — called on click (no event passed, just a flip signal)
 *   disabled    bool
 *   label       string            — shown to the left of the track
 *   hint        string            — optional small text shown to the right of the track
 *   trackStyle  object            — inline overrides on the track button
 *
 * Usage:
 *   <Toggle
 *     label="Is Buyer"
 *     checked={isBuyer}
 *     onChange={() => setIsBuyer(v => !v)}
 *   />
 *
 *   <Toggle
 *     label="Phase 1"
 *     checked={lead.meetingPaymentPaid}
 *     onChange={() => toggleField(lead.id, "meetingPaymentPaid", lead.meetingPaymentPaid)}
 *     disabled={!isAdmin}
 *     hint={lead.meetingPaymentPaid ? "Yes" : "No"}
 *   />
 */
const Toggle = React.memo(function Toggle({
  checked,
  onChange,
  disabled = false,
  label,
  hint,
  trackStyle,
}) {
  return (
    <div className={styles.toggleLabel}>
      {label && <span className={styles.toggleLabelText}>{label}</span>}
      <button
        type="button"
        className={`${styles.toggleTrack} ${checked ? styles.toggleTrackOn : ""}`}
        onClick={disabled ? undefined : onChange}
        disabled={disabled}
        style={trackStyle}
      >
        <div
          className={`${styles.toggleThumb} ${checked ? styles.toggleThumbOn : ""}`}
        />
      </button>
      {hint !== undefined && (
        <span
          style={{
            fontSize: 9,
            marginLeft: 4,
            color: checked ? "inherit" : "var(--text-muted)",
          }}
        >
          {hint}
        </span>
      )}
    </div>
  );
});

export default Toggle;
